<div class="tw-flex tw-flex-col tw-w-full">
  <span
    class="tw-font-semibold tw-text-[14px] tw-text-dt-text-secondary tw-leading-[125%] tw-tracking-[1.25%] tw-uppercase"
    >{{ title() }}</span
  >
  <div class="tw-flex tw-flex-col">
    @if (showAll()) {
      <div
        class="tw-flex tw-gap-2 tw-p-4 tw-rounded-xl"
        [ngClass]="{
          'tw-shadow-neuomorphic-inset': allSelected && !isMobile(),
          'hover:tw-bg-dt-surface-page': !isMobile(),
          'tw-bg-dt-surface-today-tertiary': isMobile() && allSelected,
        }"
      >
        <app-checkbox
          [id]="title().toLowerCase() + '-all'"
          title="All"
          [checked]="allSelected"
          [isMobile]="isMobile()"
          (onChange)="onAllChange($event)"
        ></app-checkbox>
      </div>
    }
    <div class="tw-flex tw-flex-col tw-divide-y tw-divide-color-border-subtle">
      @for (option of options(); track option.id) {
        <div
          class="tw-flex tw-gap-2 tw-p-4 tw-rounded-xl"
          [ngClass]="{
            'tw-shadow-neuomorphic-inset':
              option.selected && !parentAllSelected() && !allSelected && !isMobile(),
            'hover:tw-bg-dt-surface-page': !isMobile(),
            'tw-bg-dt-surface-today-tertiary':
              isMobile() && option.selected && !parentAllSelected() && !allSelected,
          }"
        >
          <app-checkbox
            [id]="option.id"
            [title]="option.label"
            [checked]="option.selected"
            [disabled]="option.disabled"
            [isMobile]="isMobile()"
            (onChange)="onOptionChange(option, $event)"
          ></app-checkbox>
        </div>
      }
    </div>
  </div>
</div>
